export class SectionTemplate {

    Id: number;
    SectionId: number;
    TemplateName: string;
    TemplateText: string;

    constructor() {
    }
}